export default "__VITE_ASSET__fefadd9d__"